import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'secondarySelectedItemsLabel',
})
export class SecondarySelectedItemsPipe implements PipeTransform {
  #translate = inject(TranslateService);

  public transform(
    values: string | number | (string | number)[],
    showOnlyCount = false,
    showFirstNPlusMore = 0,
    labels: { [key: string | number]: { label: string; country?: any } } = {},
  ): string | number {
    if (!Array.isArray(values)) {
      if (values === null || values === undefined || values === '') {
        return this.#translate.instant('DROPDOWNS.INNER_LABEL_NOTHING_SELECTED');
      }

      return labels?.[values]?.label ?? values;
    }

    if (showOnlyCount) {
      return values.length ?? 0;
    }

    if (showFirstNPlusMore && values.length) {
      let shownValues =
        values
          .slice(0, showFirstNPlusMore)
          .map((id) => labels?.[id]?.label ?? id)
          .join(', ') ?? '';

      if (values.length - showFirstNPlusMore > 0) {
        shownValues = shownValues + this.#translate.instant('DROPDOWNS.INNER_LABEL-SHOWCOUNT', { count: values.length - showFirstNPlusMore });
      }

      return shownValues;
    }

    // Replace shown ids with labels
    const _labels = values.map((id) => labels?.[id]?.label ?? id);

    return _labels.length ? _labels.join(', ') : this.#translate.instant('DROPDOWNS.INNER_LABEL_NOTHING_SELECTED');
  }
}
